import { Workflow } from "domain/entities/workflow";
import usePermissionCheck from "presentation/hooks/use-check-permissions";
import TaskToApprovalList from "presentation/mobile/components/Documents/TaskToApprovalList";
import TaskToApprovalListSkeleton from "presentation/mobile/components/Documents/TaskToApprovalList/Skeleton";
import { useNavigationStore } from "presentation/mobile/stores/navigation-store";
import { useEffect, useState } from "react";

const FUNCTION = "sign-documents"
const REQUIRE_FUNCTION = 'dashboards'
const LEVEL = 2;

const SignDocuments = () => {

    const {isLoading, hasPermission} = usePermissionCheck({requiredFunction: REQUIRE_FUNCTION});
    const navigationState = useNavigationStore();

    useEffect(() => {
        if(navigationState.currentRoute !== FUNCTION)
            navigationState.setCurrentRoute(FUNCTION);
    }, []);

    if(isLoading)
        return <TaskToApprovalListSkeleton />

    return (
        <TaskToApprovalList level={LEVEL} />
    )
}

export default SignDocuments;